import React from 'react';
import {
    bool,
    func,
    node,
    number,
    object,
    shape,
    string
} from 'prop-types';
import clsx from 'clsx';

import TextField from '@material-ui/core/TextField';

import defaultClasses from './TextArea.module.css';

const TextArea = ({
    fullWidth,
    InputLabelProps,
    InputProps,
    label,
    margin,
    name,
    onChange,
    rows,
    variant,
    ...props
}) => (
    <TextField
        InputLabelProps={{
            shrink:  true,
            ...InputLabelProps,
            classes: {
                ...InputLabelProps.classes,
                root: clsx(
                    defaultClasses.label,
                    InputLabelProps.classes.root
                )
            }
        }}
        InputProps={{
            ...InputProps,
            classes: {
                ...InputProps.classes,
                root: clsx(
                    defaultClasses.input,
                    InputProps.classes.root
                )
            }
        }}
        label={label}
        margin={margin}
        multiline
        name={name}
        onChange={onChange}
        rows={rows}
        variant={variant}
        {...props}
    />
);

TextArea.defaultProps = {
    InputLabelProps: {
        classes: {}
    },
    InputProps: {
        classes: {}
    },
    fullWidth: true,
    margin:    'normal',
    onChange:  () => {},
    rows:      4,
    variant:   'outlined'
};

TextArea.propTypes = {
    defaultValue:    node,
    fullWidth:       bool,
    InputLabelProps: shape({
        classes: object.isRequired
    }),
    InputProps: shape({
        classes: object.isRequired
    }),
    label:    string,
    margin:   string,
    name:     string.isRequired,
    onChange: func,
    rows:     number,
    variant:  string
};

export default TextArea;
